// extracted by mini-css-extract-plugin
export default {"section_card":"SkeletonCardsLoading_section_card__JMWh1","skeleton":"SkeletonCardsLoading_skeleton__KDMXH"};